import { render, staticRenderFns } from "./QuestionTopicCard.vue?vue&type=template&id=116a80cf&scoped=true&"
import script from "./QuestionTopicCard.vue?vue&type=script&lang=js&"
export * from "./QuestionTopicCard.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTopicCard.vue?vue&type=style&index=0&id=116a80cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a80cf",
  null
  
)

export default component.exports